import axios, { AxiosResponse } from "axios";
import { config } from "../../contexts/UrlContext";
import { toast } from "react-toastify";
import React, { useEffect, useState, useContext } from 'react';
import { Button, Dimmer, Grid, Loader } from 'semantic-ui-react';
import ErrorPage from "../ErrorPage/ErrorPage";
import { SettingsContext } from "../../contexts/SettingsContext";
import history from "../../History";
import AuthContext from "../../contexts/AuthContext";
import { postRequest } from "../../services/axiosService";


function CustomTheme() {
    const { hasAdminPrivileges } = useContext(SettingsContext);
    const { auth } = useContext(AuthContext);


    const [name, setName] = useState<string>("");
    const [customPath, setCustomPath] = useState<string>("");
    const [uploadedFiles, setUploadedFiles] = useState<any>();
  
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
       
    }, [])

    const cssFileChange = (e: any) => {
        let files = e.target.files;

        if (files !== null && files.length > 0) {
            setUploadedFiles(files);
        }
    }

    const saveSettings = async () => {
        if (name === null || name === undefined) {
            toast.error("Name cannot be left empty");
            return;
        }
        if (uploadedFiles === null || uploadedFiles === undefined) {
            toast.error("A CSS file must be uploaded");
        }
        try {
            let formData = new FormData();
            let fileInput: any = document.querySelector('#cssfile');
            let files = fileInput.files;
    
            for (let i = 0; i < files.length; i++) {
                formData.append("file", files[i]);
            }
    
            formData.append("name", name);

            let response: AxiosResponse;

            if (!auth || auth === null) {
                response = await axios.post(`${config.baseUrl}/api/Theme/UploadCustomTheme`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
            } else {
                let header = {
                    'Authorization': `Bearer ${auth.user?.access_token}`,
                    'Content-Type': 'multipart/form-data'
                }
                response = await axios.post(`${config.baseUrl}/api/Theme/UploadCustomTheme`, formData, {
                    headers: header
                })
            }
    
            toast.success("Successfully Uploaded Custom Theme");
            history.push("/CM2WebShare/Themes");
        } catch (error) {
            console.log(error);
            toast.error("An error occurred, please check logs");
        }
    }

    if (loading) {
        return (
            <Dimmer inverted active={true}>
                <Loader inverted>Loading Theme...</Loader>
            </Dimmer>
        );
    }
    else if (!hasAdminPrivileges) {
        return (
            <ErrorPage title="Access Denied" message=" Only Administrators and Records Managers can view this page" />
        )
    }
    else {
        return (
            <div className="ui container" id="theme-settings">     
                <div className="header blue headerStyleBlue" style={{marginTop:15}}>Upload Custom Theme</div>
                <div className="header gray headerStyleGray">THEME NAME</div>
                <div className="ui input fluid" style={{ marginLeft: '10px' }} >
                    <input type="text" style={{ backgroundColor: "#e5e5e5" }} placeholder="Enter Theme Name" id="theme-name" value={name} onChange={(e) => { setName(e.target.value) }} />
                </div>
                <div className="header gray headerStyleGray">CUSTOM CSS FILE</div>
                <div className="upload-btn-wrapper" style={{ marginLeft: 5 }}>
                    <button className="ui button" id="importButton"> Upload CSS File </button>
                    <input type="file" name="myfile" id="cssfile" accept=".css" multiple onChange={cssFileChange} style={{ height: "95%", width: "100%" }} />
                </div>

                <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "left", alignContent: "stretch", margin: 10 }}>
                    <Button id="theme-save" style={{ marginTop: 20 }} onClick={saveSettings}>Save</Button>
                    <Button id="theme-cancel" style={{ marginTop: 20, marginLeft: 5 }} onClick={() => history.push("/CM2WebShare/Themes")}>Cancel</Button>
                </div>
            </div>
        );
    } 
}

export default CustomTheme;